import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';
import { Map as ImmutableMap } from 'immutable';

import type { GeneratorDialogProps } from './types';

export const GENERATOR_DIALOG = 'GENERATOR_DIALOG';

export const dispatchGeneratorDialog = (props?: GeneratorDialogProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: GENERATOR_DIALOG,
        props: ImmutableMap(props || {}),
      }),
    ),
  );
};

export default dispatchGeneratorDialog;
